<template>
    <div>
        <p class="body-1 grey--text text--darken-1 mt-4">{{ $t('label.approvalDetails')}}</p>
        <form>
            <v-card class="pa-3">
                <v-card-text>
                    <v-layout row>
                        <v-flex xs3 lg2>
                            <label class="form-label">{{ $t('label.person') }}</label>
                        </v-flex>
                        <v-flex xs7 lg5>
                            <span class="form-value">{{ item.responsible.name }}</span>
                        </v-flex>
                    </v-layout>
                    <v-layout row>
                        <v-flex xs3 lg2>
                            <label class="form-label">{{ dateLabel }}</label>
                        </v-flex>
                        <v-flex xs7 lg5>
                            <span class="form-value">{{ dateApproved }}</span>
                        </v-flex>
                    </v-layout>
                    <v-layout row>
                        <v-flex xs3 lg2>
                            <label class="form-label">{{ $t('label.comments') }}</label>
                        </v-flex>
                        <v-flex xs9 lg10>
                            <span class="form-value">{{ item.comments }}</span>
                        </v-flex>
                    </v-layout>
                    <v-layout row v-if="item.files !== undefined && item.files.length > 0">
                        <v-flex xs3 lg2>
                            <label class="form-label">{{ $t('label.files') }}</label>
                        </v-flex>
                        <v-flex xs9 lg10>
                            <app-files :files="item.files"></app-files>
                        </v-flex>
                    </v-layout>
                </v-card-text>
            </v-card>
        </form>
    </div>
</template>

<script>
import constants from '@/helpers/constants';
import { dateToLongString } from '@/helpers/filters';
import Files from '@/components/shared/Files';

export default {
    props: {
        item: {
            type: Object,
            required: true,
        },
    },
    computed: {
        dateApproved() {
            return dateToLongString(this.item.dateApproved);
        },
        dateLabel() {
            if (this.item.event.id === constants.EVENT_APPROVED) return this.$t('label.dateApproved');

            return this.$t('label.dateRejected');
        },
    },
    components: {
        appFiles: Files,
    },
};
</script>



// WEBPACK FOOTER //
// src/components/demands/shared/WorkflowItemDetail.vue